/** Admin QR-voucher detail (view + delete) for one owner. */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../../src/context/OwnerScopeContext';
import QrDetailScreen from '../../../../../owner/subscriptions/qr-codes/[id]';

export default function AdminOwnerQrDetailScreen() {
  const { id, voucherId } = useLocalSearchParams<{ id: string; voucherId: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <QrDetailScreen entityId={voucherId} />
    </OwnerScopeProvider>
  );
}
